export const getHlsParam = (anonymize?: boolean, labels?: boolean) => {
    return !!(anonymize || labels);
};
